import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function Toaster() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={false}
      hideProgressBar
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      closeButton={false}
      className="top-[88px] right-4"
      toastClassName={'!p-0 rounded-xl !shadow-none justify-center text-white'}
    />
  );
}

export default Toaster;
